

import { Subject } from 'rxjs';
import { throttleTime } from 'rxjs/operators';
import * as Configuration from '../../app.constants.js';

export class MetricsService {

  queriesWithThrottleTime$ = new Subject().pipe(throttleTime(300));
  selectTabWithThrottleTime$ = new Subject().pipe(throttleTime(300));

  constructor($http, AsyncRequestFactory) {
    this.$http = $http;
    this.AsyncRequestFactory = AsyncRequestFactory;
  }

  formatFromDateForDayRangeQuery(from) {
    return from.getFullYear() + '-' + (from.getMonth() + 1) + '-' + from.getDate() + ' 00:00:00';
  }

  formatToDateForDayRangeQuery(to) {
    return to.getFullYear() + '-' + (to.getMonth() + 1) + '-' + to.getDate() + ' 23:59:59';
  }

  getReportDate(companyId, reportId){
    return this.$http.get(Configuration.constants.baseUrl +'api/1.0/companies/' + companyId + '/metrics-reports/'+ reportId+'/date');
  }

  /**
   * @deprecated migrated in reports.service.ts in getMetricsReport()
   */
  getReport(companyId, reportId) {
    return this.$http.get(Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/metrics-reports/' + reportId);
  }

  getScenarios(companyId, scenariosFlavor) {
    return this.$http.get(Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/scenarios/', {params: {flavor: scenariosFlavor}});
  }

  createQuery(companyId, metricId, data) {
    return this.AsyncRequestFactory.post(companyId, Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/metrics/' + metricId + '/queries', data);
  }
  createExport(companyId, metricId, queryId, data) {
    return this.AsyncRequestFactory.post(companyId, Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/metrics/' + metricId + '/queries/' + queryId + '/exports', data)
  }
  createDetailsExport(companyId, metricId, queryId, data, format) {
    return this.AsyncRequestFactory.post(companyId, Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/metrics/' + metricId + '/queries/' + queryId + '/details-exports/' + format, data);
  }

  getMetricsReportStateForMode(navigationMode) {
    return navigationMode === 'care' ? 'auth.alcmeon.fuse.metrics-and-reports':  'auth.alcmeon.fuse.marketing-metrics-and-reports'
  }

  getMinDate(name) {
    switch (name) {
      case 'logged_in_time':
        // we activate the date-range selector for dates higher than the 
        // deployment date of the logged_in_time page 
        return '2023-05-22T00:00:00.000Z';
      default:
        return null;
    }
  }

  static MetricsFactory($http, AsyncRequestFactory) {
    return new MetricsService($http, AsyncRequestFactory);
  }
}

MetricsService.MetricsFactory.$inject = ['$http', 'AsyncRequestFactory'];

